<template>
    <v-container fluid>
        <v-btn
            :loading="areasWithInfo === null"
            @click="newArea"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Areas ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="areasWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="areaWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="areaWithInfo in areasWithInfo"
                >
                    <!--@click="loadAreaForm(areaWithInfo.entity)"-->
                    <v-card
                    @click="loadAreaForm(areaWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>{{areaWithInfo.entity.name}}</h5>
                        </v-card-title>
                        <!--<v-card-text class="pt-0">Customers: {{providerGroupWithInfo.info.customerCount}}</v-card-text>-->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            persistent
            v-model="areaFormVisible"
            width="500px"
        >
            <AreaForm
                :key="areaFormKey"
                :area-in="areaFormArea"
                @close="closeAreaForm"
                @deleted="deleteArea"
                @saved="updateArea"
            />
        </v-dialog>


        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Area from "../models/Area.model";
import uuid4 from "../helpers/uuid4";
import Area from "../models/Area.model";
import AreaForm from "../components/forms/AreaForm"

export default {
    name: "Areas",
    props: ["status"],
    data: function() {
        return {
            //main data
            areasWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            areaFormVisible: false,
            areaFormKey: 0,
            areaFormArea: new Area()
        };
    },
    mounted: function() {
        this.getAreas();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        AreaForm
        //
    },
    methods: {
        getAreas() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("areas/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(areasResponse => {
                    if (this.requestId == areasResponse.requestId) {
                        this.areasWithInfo = areasResponse.data.page;
                        this.totalMatches = areasResponse.data.total;
                        this.pageSize = areasResponse.data.pageSize;
                        this.pageNo = areasResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            areasResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.areasWithInfo !== null) this.areasWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getAreas,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newArea() {
            var area = new Area();
            area.id = 0;
            this.loadAreaForm(area);
        },
        loadAreaForm(area) {
            this.areaFormArea = new Area().set(area);
            this.areaFormKey = area.id;
            this.areaFormVisible = true;
        },
        closeAreaForm() {
            this.areaFormVisible = false;
            this.areaFormArea = new Area();
            this.areaFormKey = null;
        },
        updateArea() {
            this.paginationDebounce(0);
        },
        deleteArea() {
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
